var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { cursor: "pointer" } }, [
    _c("div", { staticClass: "card-title" }, [
      _vm._v(" " + _vm._s(_vm.getCardTitle))
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex", margin: "8px 0" } }, [
      _c("div", { staticClass: "card-subtitle" }, [
        _vm._v(_vm._s(_vm.getCardType))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-date" }, [_vm._v(_vm._s(_vm.formatDate))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }